// PSSE Raw file data structures

export enum BusType {
  LOAD = 1,
  GENERATOR = 2,
  SWING = 3
}

export enum ComponentStatus {
  OUT_OF_SERVICE = 0,
  IN_SERVICE = 1
}

export interface PSSEBus {
  number: number;
  name: string;
  baseKV: number;
  busType: BusType;
  area: number;
  zone: number;
  owner: number;
  voltageMagnitude: number;
  voltageAngle: number;
}

export interface PSSELoad {
  busNumber: number;
  loadId: string;
  status: ComponentStatus;
  area: number;
  zone: number;
  realPowerMW: number;
  reactivePowerMVAR: number;
  constantPowerReal: number;
  constantPowerReactive: number;
  constantCurrentReal: number;
  constantCurrentReactive: number;
  owner: number;
  scale: number;
}

export interface PSSEGenerator {
  busNumber: number;
  generatorId: string;
  realPowerMW: number;
  reactivePowerMVAR: number;
  maxReactiveMVAR: number;
  minReactiveMVAR: number;
  voltageMagnitude: number;
  remoteBusNumber: number;
  maxRealPowerMW: number;
  minRealPowerMW: number;
  machineBaseKVA: number;
  impedanceReal: number;
  impedanceReactive: number;
  status: ComponentStatus;
  ratedRealPowerMW: number;
}

export interface PSSEFixedShunt {
  busNumber: number;
  shuntId: string;
  status: ComponentStatus;
  conductanceMW: number; // GL: active component at 1 pu voltage (MW)
  susceptanceMVAR: number; // BL: reactive component at 1 pu voltage (Mvar, + for a capacitor)
}

export interface PSSEBranch {
  fromBus: number;
  toBus: number;
  circuitId: string;
  resistance: number;
  reactance: number;
  chargingSusceptance: number;
  rateA: number;
  rateB: number;
  rateC: number;
  tapRatio: number;
  phaseShift: number;
  fromBusShunt: number;
  toBusShunt: number;
  status: ComponentStatus;
}

export interface PSSETransformer {
  fromBus: number;
  toBus: number;
  tertiaryBus: number;
  circuitId: string;
  windingDataI: number;
  windingDataJ: number;
  windingDataK: number;
  magnetizingAdmittanceG: number;
  magnetizingAdmittanceB: number;
  windingCount: number;
  resistance: number;
  reactance: number;
  baseMVA: number;
  tapRatio: number;
  phaseShift: number;
}

export interface PSSEData {
  header: {
    ic: number;
    sbase: number;
    rev: number;
    xfrrat: number;
    nxfrat: number;
    basfrq: number;
    title1: string;
    title2: string;
  };
  buses: PSSEBus[];
  loads: PSSELoad[];
  fixedShunts: PSSEFixedShunt[];
  generators: PSSEGenerator[];
  branches: PSSEBranch[];
  transformers: PSSETransformer[];
}